<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">مميزات العقارات</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">مميزات العقارات</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="checkAccess('property_features_create')" class="row">
          <div class="col text-end">
            <router-link to="/featurescreate" class="btn btn-primary">
              <i class="bi bi-plus-circle me-1"></i> إضافة ميزة عقار
            </router-link>
          </div>
        </div>

        <div v-if="isLoading" class="text-center">
          <mainLoader />
        </div>
        <div v-if="hasError" class="text-center pt-3">
          <errorAlert :alertMessage="message" />
        </div>
        <div v-if="!isLoading" class="row justify-content-center overflow-auto mb-4 mt-5">
          <div class="col-12 col-md-11 pe-5">
            <table class="table table-striped table-hover text-center">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">الايقونة</th>
                  <th scope="col">الاسم - عربي</th>
                  <th scope="col">الاسم - إنجليزي</th>
                  <th scope="col">الحاله</th>
                  <th scope="col">اخر تحديث</th>
                  <th scope="col">التعديل</th>
                  <th v-if="checkAccess('property_features_delete')" scope="col">الحذف</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in rows" :key="index">
                  <td class="counter"></td>
                  <td>
                    <img :src='MEDIA_URL+row.icon' alt="" class="img-thumbnail grid-img">
                  </td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.nameEn }}</td>
                  <td>{{ (row.isActive)? 'نشط' : 'غير نشط' }}</td>
                  <td>{{ $shortDate(row.updatedAt) }}</td>
                  <td>
                    <router-link v-if="checkAccess('property_features_update')" :to="'/featuresupdate/'+row.id">
                      <i class="bi bi-card-list"></i>
                    </router-link>
                    <router-link v-else :to="'/featuresRead/'+row.id">
                      <i class="fa-regular fa-eye"></i>
                    </router-link>
                  </td>
                  <td v-if="checkAccess('property_features_delete')">
                    <a @click.prevent="deleteItem(index, row.id)">
                      <i class="bi bi-archive text-red pointer-mouse"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import { toast, checkAccess } from '@/helpers/tools';
export default {
  name: "featuresview",
  data(){
    return{
      isLoading: false,
      hasError: false,
      message: "",
      rows: [],
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  methods: {
    checkAccess, 
    getData(){
      this.isLoading = true;
      this.hasError = false,
      this.$http.get('/api/admin/propertyFeatures/list').then(res => {
        // console.log(res);
        this.isLoading = false;
        this.rows = res.data.propertyFeatures;
      }).catch (err => {
        // console.log(err);
        this.message = this.$globalError(err);
        this.hasError = true;
        this.isLoading = false;
        window.scroll(0,0);
      });
    },
    deleteItem(index, id) {
      this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.delete(`/api/admin/propertyFeatures/delete/${id}`).then(({data}) => {
            this.rows.splice(index, 1);
            toast('تم حذف السجل بنجاح', 'success');
          }).catch(err => {
            toast('غير قادر على حذف السجل');
          });
        }
      });
    },
  },
  created(){
    this.getData();
  }
}
</script>